import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useWorkspaceName } from './useWorkspaceName';

const WORKSPACE_BADGE_CAP = 36;

export function capWorkspaceLabel(name: string) {
  if (name.length <= WORKSPACE_BADGE_CAP) return name;
  return `${name.slice(0, WORKSPACE_BADGE_CAP)}...`;
}

export function WorkspaceNameBadge({ name }: { name: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={
            <Badge
              variant="outline"
              className="tw:h-5 tw:shrink-0 tw:!justify-start tw:px-1.5 tw:text-left tw:text-[10px] tw:font-medium"
            >
              {capWorkspaceLabel(name)}
            </Badge>
          }
        />
        <TooltipContent align="start">{name}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function LayerWorkspaceBadge({
  incidentId,
  incidentName,
}: {
  incidentId?: string | null;
  incidentName?: string | null;
}) {
  const workspaceName = useWorkspaceName(incidentId, incidentName);
  if (!workspaceName) return null;
  return <WorkspaceNameBadge name={workspaceName} />;
}
